/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackgroundJobResponse
 */
export interface BackgroundJobResponse {
    /**
     * 
     * @type {number}
     * @memberof BackgroundJobResponse
     */
    jobId: number;
}

export function BackgroundJobResponseFromJSON(json: any): BackgroundJobResponse {
    return BackgroundJobResponseFromJSONTyped(json, false);
}

export function BackgroundJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackgroundJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['job_id'],
    };
}

export function BackgroundJobResponseToJSON(value?: BackgroundJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_id': value.jobId,
    };
}

